import React from "react";

const POINTS = [
  {
    title: "Exam-Centric Learning",
    body:
      "Students focus on memorisation and test scores, but retain little long-term understanding or transferable skills.",
  },
  {
    title: "Lack of Soft Skill Development",
    body:
      "Core competencies like emotional intelligence (EQ), adversity quotient (AQ), resilience, and collaboration are often overlooked or poorly developed.",
  },
  {
    title: "Unstructured Experiential Learning",
    body:
      "Learning by doing is essential, but it is often unguided. Teachers struggle to teach reflection, mindset, and real-world readiness consistently and measurably.",
  },
];

const ProfEPainpoints: React.FC = () => (
  <section className="pe-section pe-section--white pe-points">
    <div className="pe-container">
      <div className="pe-eyebrow">Hidden Crisis in Education</div>
      <h2 className="pe-points__h">
        Over 70% of students forget most of what they&rsquo;ve learnt within weeks.
      </h2>
      <ol className="pe-points__grid">
        {POINTS.map((p, i) => (
          <li className="pe-points__card" key={p.title}>
            <div className="pe-points__num">{i + 1}</div>
            <h3 className="pe-points__title">{p.title}</h3>
            <p className="pe-points__body">{p.body}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default ProfEPainpoints;
